// @flow
import type { State } from 'store/State';

/** Returns true if the user is logged in */
export function isLoggedIn(state: State): boolean {
  return Boolean(state.user.personInfo);
}



// WEBPACK FOOTER //
// ./src/store/reducers/user/selectors.js